import { Button, Input } from '@bfe/moly';
import { Form } from 'antd';
import { useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import {
  LOGIN_NAME_REGEX,
  LOGIN_PASSWORD_REGEX,
} from '@/utils/constants/sub-account';

import { ValidateTypes } from '../../security/types';

const FormContent = ({
  captchaV2Loading,
  onHandleLogin,
}: {
  captchaV2Loading: boolean;
  onHandleLogin: (params: { loginName: string; password: string }) => void;
}) => {
  const [$t] = useI18nContext();

  const [form] = Form.useForm();
  const [userNameValid, setUserNameValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [disabled, setDisabled] = useState(true);

  // 用户名校验
  const validateUserName = (val: ValidateTypes, username: string) => {
    const isReg = LOGIN_NAME_REGEX.test(username);
    if (!isReg) {
      setUserNameValid(false);
      return Promise.reject($t('child.subaccountLoginNameErrTip'));
    } else {
      setUserNameValid(true);
      return Promise.resolve(true);
    }
  };

  // 密码格式校验
  const validatePassWord = (val: ValidateTypes, password: string) => {
    const isMatch = LOGIN_PASSWORD_REGEX.test(password);
    if (!isMatch) {
      setPasswordValid(false);
      return Promise.reject($t('child.subaccountLoginPasswordErrTip'));
    } else {
      setPasswordValid(true);
      return Promise.resolve(true);
    }
  };

  // 值变更时，如果用户名或者密码格式错误，登录按钮禁用
  const onValuesChange = () => {
    if (userNameValid && passwordValid) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  return (
    <>
      <div className="sub-account-login-container-top-form">
        <Form form={form} layout="vertical" onFieldsChange={onValuesChange}>
          <Form.Item
            name="username"
            rules={[
              {
                required: false,
                validator: validateUserName,
              },
            ]}
          >
            <Input placeholder={$t('child.loginName')} />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: false,
                validator: validatePassWord,
              },
            ]}
          >
            <Input
              type="password"
              placeholder={$t('Password')}
              visible
              allowClear
            />
          </Form.Item>
        </Form>
      </div>
      <div className="sub-account-login-container-top-button">
        <Button
          disabled={disabled}
          variant="primary"
          className="bybit-ghost"
          onClick={() => {
            onHandleLogin({
              loginName: form.getFieldValue('username'),
              password: form.getFieldValue('password'),
            });
          }}
          loading={captchaV2Loading}
        >
          {$t('Login')}
        </Button>
      </div>
    </>
  );
};

export default FormContent;
